// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7xyxn","type":"styles_type__1DC9N","choices":"styles_choices__3tQWX"};